// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/blocks.scss
// module id = 15
// module chunks = 1